export default "__VITE_ASSET__DImrO013__"